module.exports = __webpack_public_path__ + "static/amplify-image-25be94dcd2dab645c9108de744291a98.png";